@if (active()) {
  <div class="placement-layer" (click)="onClick($event)" (mousemove)="onMove($event)"></div>
  <div class="placement-hint" [style.left.px]="hintX()" [style.top.px]="hintY()">
    Click anywhere to drop a pin <kbd>Esc</kbd>
  </div>
}
